import { isTwoFactorRequiredError } from '@/features/twoFactor/entities';

// handleTwoFactorRedirect trata o 403 do gate de 2FA em QUALQUER tela, nao so no login.
// O gate pode disparar no meio da sessao — por exemplo quando um administrador liga o
// 2FA de alguem que ja esta logado. Sem isto, essa pessoa veria erro generico em cada
// acao, sem entender o motivo e sem caminho de saida.
//
// NAO chama logout(): a sessao e recuperavel digitando o codigo. Limpar o storage
// destruiria justamente o que o usuario pode recuperar e o mandaria de volta para a
// senha sem explicacao. Mantendo o token, o Login.tsx monta, chama my-companies,
// recebe o mesmo 403 e mostra o card do codigo — a maquina de estados que ja existe.
export const handleTwoFactorRedirect = (error: unknown): boolean => {
  if (!isTwoFactorRequiredError(error)) return false;

  // Ja estando no login, redirecionar recarregaria a pagina em laco.
  if (window.location.pathname.startsWith(`/login`)) return false;

  window.location.replace(`/login`);
  return true;
};
